import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { selectLocaleId } from 'data/store-selectors';
import { getDatePickerLocale } from './datePickerLocales';

const DatePickerLocalizationProvider = ({ children }: PropsWithChildren) => {
    const localeId = useSelector(selectLocaleId);

    return (
        <LocalizationProvider
            key={localeId}
            dateAdapter={AdapterMoment}
            dateLibInstance={moment}
            {...getDatePickerLocale(localeId)}
        >
            {children}
        </LocalizationProvider>
    );
};

export default DatePickerLocalizationProvider;
